import { useState } from 'react';
import { motion } from 'framer-motion';

export function FuturesDesk() {
  const [strike, setStrike] = useState(70);
  const [date, setDate] = useState<string>(new Date(Date.now()+7*24*3600*1000).toISOString().slice(0,10));
  const [stake, setStake] = useState(1);
  const [market, setMarket] = useState(72);

  const create = () => alert(`Create future: strike €${strike}/t, settle ${date}, stake ${stake} ETH`);
  const settle = () => alert(`Settle at market €${market}/t`);

  const pnl = market - strike; // demo
  const risk = Math.abs(pnl) > 10 ? 'HIGH' : Math.abs(pnl) > 5 ? 'MEDIUM' : 'LOW';

  return (
    <div className="space-y-3">
      <div className="font-orbitron text-evat-gold">ESG Futures Desk</div>
      <div className="text-xs text-yellow-400">Risk Warning: Derivatives carry significant risk</div>
      <div className="grid grid-cols-1 sm:grid-cols-5 gap-2 text-sm">
        <label className="flex items-center gap-2">Strike €/t
          <input type="number" value={strike} onChange={(e)=>setStrike(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 w-24"/>
        </label>
        <label className="flex items-center gap-2">Settlement
          <input type="date" value={date} onChange={(e)=>setDate(e.target.value)} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1"/>
        </label>
        <label className="flex items-center gap-2">Stake
          <input type="number" step="0.1" value={stake} onChange={(e)=>setStake(Number(e.target.value))} className="bg-black border border-evat-gold text-evat-gold rounded px-2 py-1 w-24"/>
        </label>
        <motion.button whileTap={{scale:0.97}} onClick={create} className="px-3 py-1 rounded border border-evat-neon text-evat-neon">Create</motion.button>
        <div className="text-xs text-neutral-400">Risk: <span className={risk==='HIGH'?'text-red-400':risk==='MEDIUM'?'text-yellow-400':'text-emerald-400'}>{risk}</span></div>
      </div>
      <div className="flex items-center gap-2 text-sm">
        <label className="flex items-center gap-2">Market €/t
          <input type="number" value={market} onChange={(e)=>setMarket(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 w-24"/>
        </label>
        <div>PnL (demo): <span className={pnl>=0?'text-emerald-400':'text-red-400'}>{pnl.toFixed(1)}</span></div>
        <motion.button whileTap={{scale:0.97}} onClick={settle} className="px-3 py-1 rounded border border-evat-gold text-evat-gold">Settle</motion.button>
      </div>
    </div>
  );
}

export default FuturesDesk;



















